
import Typography from '@material-ui/core/Typography';


const Copyright = () => {
  return (
    <Typography variant="body2" align="center">
      {" © "}
      {new Date().getFullYear()} &nbsp;
      <a href="https://jamanenterprise.in" style={{ color: "#f6a831" }} target="_blank" rel="noreferrer">
        Jaman Enterprise
      </a>
      {"."}
      <p style={{ fontFamily: "Pacifico" }}>
        {" "}
        Developed by &nbsp;
        <a href="https://www.facebook.com/d3vjamal" target="_blank" rel="noreferrer">
          {" "}
          Jamal
        </a>
      </p>
    </Typography>
  );
}

export default Copyright;